import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import kitchen from "assets/images/Services/Tenancy/kitchen1.jpg";
import bathroom from "assets/images/Services/Tenancy/bathroom1.jpg";
import livingBedroom1 from "assets/images/Services/Tenancy/living-bedroom1.jpg";
import hallwaysEntry from "assets/images/Services/Tenancy/hallways-entry1.jpg";
import additional1 from "assets/images/Services/Tenancy/additional1.jpg";

// Data for Post-Construction Cleaning Services
const cleaningCategories = [
  {
    image: kitchen,
    name: "Dust and Debris Removal",
    position: { color: "info", label: "" },
    description: [
      "Removing construction dust and debris from all surfaces",
      "Vacuuming and mopping floors to eliminate residue",
    ],
  },
  {
    image: bathroom,
    name: "Detailed Surface Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Wiping down walls, ceilings, and baseboards",
      "Cleaning windows, frames, and sills (interior)",
    ],
  },
  {
    image: livingBedroom1,
    name: "Kitchen and Bathroom Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Polishing countertops, cabinets, and sinks",
      "Scrubbing and sanitizing bathroom fixtures and tiles",
    ],
  },
  {
    image: hallwaysEntry,
    name: "Appliance and Fixture Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Wiping down new appliances and light fixtures",
      "Removing protective films and labels",
    ],
  },
  {
    image: additional1,
    name: "Final Touches",
    position: { color: "info", label: "" },
    description: [
      "Polishing mirrors, glass surfaces, and hardware",
      "Ensuring a spotless and presentable finish",
    ],
  },
];

function PostConstruction_Section2() {
  return (
    <Container>
      <Grid container direction="column" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our Post-Construction Cleaning Services?"
            contents="We leave no stone unturned when it comes to making your space spotless:"
          />
        </Grid>
        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default PostConstruction_Section2;
